import axios from 'axios'
// import qs from 'qs'
import rootApi from '@/rootUrl'
const root = rootApi //接口API
// const root = "https://stuapi.kidcastle.cn"
const url = {
  getStuTexts: `${root}/Audio/getStuTexts`,
  getStuCode: `${root}/Audio/getStuCode`,
  getUnits: `${root}/Audio/getUnits`,
  getVoices: `${root}/Audio/getVoices`,
}
const mp3Store = {
  getStuTexts(params: any) {
    return axios.get(url.getStuTexts, { params })
  },
  getStuCode(params: any) {
    return axios.get(url.getStuCode, { params })
  },
  getUnits(params: any) {
    return axios.get(url.getUnits, { params })
  },
  getVoices(params: any) {
    return axios.get(url.getVoices, { params })
  },
}

export default mp3Store;